<!-- HTML report section -->
<!-- Represents one group, produced by the reportBuilder classes -->
<template>
    <v-layout row wrap class="pt-0 pl-0 pr-0 pb-3 encode">
      <v-layout class="blue-background white--text">
        <v-flex xs9>
          <div
            class="encode title font-weight-black white--text all-upper-case pl-3 pt-3 pb-1"
          >{{ name }}</div>
          <div class="encode subheading font-weight-black font-italic pl-3 pb-3"
          >{{ title }}</div>
        </v-flex>
        <v-flex xs3 class="pb-2 pr-0">
          <v-layout justify-end>
            <v-avatar size="100px" tile>
              <!-- <img align-right style="background: #004a80" :src="require('@/assets/'+image+'.png')" alt="STP"> -->
              <img
                align-right
                style="background: #004a80"
                :src="require('@/assets/groups/'+groupId+'.png')"
                :alt="'image for ' + name"
              >
            </v-avatar>
          </v-layout>
        </v-flex>
      </v-layout>

      <!-- This section contains pre-formatted HTML, produced from -->
      <!-- raw text input by SectionAggregator.  -->
      <v-flex xs12 class="pt-3 pb-3">
        <div v-html="intro"></div>
      </v-flex>

      <template v-if="hasScore">
        <!--
        <v-flex xs12 class="blue-background white--text">
          <div class="encode title font-weight-black pa-3">Score</div>
        </v-flex>
        -->
        <v-flex xs6 v-if="inputs.length > 0" class="pt-3 pb-3">
          <dl>
            <template v-for="(input,index) in inputs">
              <dt class="font-weight-bold" :key="'q'+index">{{ input.question }}</dt>
              <dd class="pl-2" :key="'a'+index">{{ input.answer }}</dd>
            </template>
          </dl>
        </v-flex>

        <v-flex xs6 class="pt-0 pb-3">
          <div>
            <vue-c3 :handler="handler"></vue-c3>
          </div>
          <!--
          <div class="text-xs-center">You scored {{formattedScore}} out of 5.</div>
          -->
        </v-flex>
      </template>

      <template v-if="hasTips">
        <v-flex xs12 ml-2 mb-2 mr-2>
          <v-card class="white-background blue-text" raised>
            <v-card-title class="pb-0">
              <h3>Tips</h3>
            </v-card-title>
            <v-card-text>
              <div v-html="tips"></div>
            </v-card-text>
          </v-card>
        </v-flex>
      </template>

      <template v-if="shouldTrace">
        <v-flex xs12 class="grey-background blue-text" ml-2 mr-2>
          <div class="encode title font-weight-black pa-3">Trace</div>
        </v-flex>
        <v-flex xs12 class="white-background blue-text trace-table" ml-2 mr-2>
          <table>
            <thead>
              <tr>
                <th align="left">Question</th>
                <th align="left">Answer</th>
                <th align="left">Text</th>
                <th align="right">Unweighted</th>
                <th align="right">Weight</th>
                <th align="right">Weighted</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="i in answers.items" :key="i.qid">
                <td>{{ i.qid }}</td>
                <td>{{ Array.isArray(i.value) ? i.value.join(',') : i.value }}</td>
                <td>{{ i.response }}</td>
                <td align="right">{{ traceFmt(i.unweightedScore) }}</td>
                <td align="right">{{ i.weighting }} / 5</td>
                <td align="right">{{ traceFmt(i.weightedScore) }}</td>
              </tr>
              <tr>
                <td>Total</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td align="right">{{ traceFmt(answers.unweightedScore) }}</td>
              </tr>
            </tbody>
          </table>
        </v-flex>
      </template>
    </v-layout>
</template>

<style scoped>
@import "../assets/styles/styles.css";
</style>

<script>
import Vue from "vue";
import VueC3 from "vue-c3";
import { formatNumber } from "../utils/std.js";

export default {
  name: "ReportSection",
  props: {
    groupId: String, 
    name: String,
    title: String,
    intro: String,
    tips: String,
    hasTips: Boolean,
    unweightedScore: Number,
    image: String,
    hasScore: Boolean,
    inputs: Array,
    trace: Boolean,
    answers: Object
  },
  components: {
    VueC3
  },
  data() {
    return {
      handler: new Vue()
    };
  },
  computed: {
    formattedScore() {
      return formatNumber(this.unweightedScore, 1);
    },
    shouldTrace() {
      return !!this.$route.query.trace;
    }
  },
  methods: {
    traceFmt: function(val) {
      return formatNumber(val, 2);
    }
  },
  mounted() {
    // For details see https://c3js.org/samples/chart_gauge.html
    // See also https://stackoverflow.com/questions/33109596/can-the-default-arc-color-be-set-in-a-c3-js-gauge
    const options = {
      data: {
        columns: [[ this.name, this.unweightedScore ]],
        type: "gauge"
      },
      tooltip: {
        show: false
      },
      gauge: {
        min: 0,
        max: 5,
        units: " / 5",
        label: {
          // eslint-disable-next-line no-unused-vars
          format: function(value, ratio) {
            return formatNumber(value, 1);
          },
          show: false // to turn off the min/max labels.
        }
      },
      color: {
        pattern: ["#FF0000", "#F97600", "#F6C600", "#60B044"], // the three color levels for the percentage values.
        threshold: {
          values: [1, 3, 4, 4.5]
        }
      },
      size: {
        height: 180
      }
    };
    this.handler.$emit("init", options);
  }
};
</script>
